export const DEFAULT_ICON_COLOR = '#B7C1D4';
